import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { FacetFilterPropTypes } from "./FacetFilterProps";
import { FacetAccessor } from "../../../../core";
import { FastClick, renderComponent, SearchkitComponent } from "../../../../core/react";
import { CheckboxItemList, Panel } from "../../../ui";

var identity = require("lodash/identity");

export var FacetFilter =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(FacetFilter, _SearchkitComponent);

  function FacetFilter(props) {
    var _this;

    _classCallCheck(this, FacetFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FacetFilter).call(this, props));
    _this.toggleViewMoreOption = _this.toggleViewMoreOption.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FacetFilter, [{
    key: "getAccessorOptions",
    value: function getAccessorOptions() {
      var _this$props = this.props,
          field = _this$props.field,
          id = _this$props.id,
          operator = _this$props.operator,
          title = _this$props.title,
          include = _this$props.include,
          exclude = _this$props.exclude,
          size = _this$props.size,
          translations = _this$props.translations,
          orderKey = _this$props.orderKey,
          orderDirection = _this$props.orderDirection,
          fieldOptions = _this$props.fieldOptions;
      return {
        id: id,
        operator: operator,
        title: title,
        size: size,
        include: include,
        exclude: exclude,
        field: field,
        translations: translations,
        orderKey: orderKey,
        orderDirection: orderDirection,
        fieldOptions: fieldOptions
      };
    }
  }, {
    key: "defineAccessor",
    value: function defineAccessor() {
      return new FacetAccessor(this.props.id, this.getAccessorOptions());
    }
  }, {
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      var blockName = this.props.mod || "sk-refinement-list";
      return {
        container: blockName,
        option: "".concat(blockName, "-option")
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.operator != this.props.operator) {
        this.accessor.options.operator = this.props.operator;
        this.searchkit.performSearch();
      }
    }
  }, {
    key: "toggleFilter",
    value: function toggleFilter(key) {
      this.accessor.state = this.accessor.state.toggle(key);
      this.searchkit.performSearch();
    }
  }, {
    key: "setFilters",
    value: function setFilters(keys) {
      this.accessor.state = this.accessor.state.setValue(keys);
      this.searchkit.performSearch();
    }
  }, {
    key: "toggleViewMoreOption",
    value: function toggleViewMoreOption(option) {
      this.accessor.setViewMoreOption(option);
      this.searchkit.performSearch();
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return this.accessor.getBuckets().length != 0;
    }
  }, {
    key: "getSelectedItems",
    value: function getSelectedItems() {
      return this.accessor.state.getValue();
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return this.props.bucketsTransform(this.accessor.getBuckets());
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.accessor) return null;
      var _this$props2 = this.props,
          listComponent = _this$props2.listComponent,
          containerComponent = _this$props2.containerComponent,
          showCount = _this$props2.showCount,
          title = _this$props2.title,
          id = _this$props2.id,
          countFormatter = _this$props2.countFormatter;
      return renderComponent(containerComponent, {
        title: title,
        className: id ? "filter--".concat(id) : undefined,
        disabled: !this.hasOptions()
      }, [renderComponent(listComponent, {
        key: "listComponent",
        items: this.getItems(),
        itemComponent: this.props.itemComponent,
        selectedItems: this.getSelectedItems(),
        toggleItem: this.toggleFilter.bind(this),
        setItems: this.setFilters.bind(this),
        docCount: this.accessor.getDocCount(),
        showCount: showCount,
        translate: this.translate,
        countFormatter: countFormatter
      }), this.renderShowMore()]);
    }
  }, {
    key: "renderShowMore",
    value: function renderShowMore() {
      var _this2 = this;

      var option = this.accessor.getMoreSizeOption();

      if (!option || !this.props.showMore) {
        return null;
      }

      return React.createElement(FastClick, {
        handler: function handler() {
          return _this2.toggleViewMoreOption(option);
        },
        key: "showMore"
      }, React.createElement("div", {
        "data-qa": "show-more",
        className: this.bemBlocks.container("view-more-action")
      }, this.translate(option.label)));
    }
  }]);

  return FacetFilter;
}(SearchkitComponent);
FacetFilter.propTypes = FacetFilterPropTypes;
FacetFilter.defaultProps = {
  listComponent: CheckboxItemList,
  containerComponent: Panel,
  size: 50,
  collapsable: false,
  showCount: true,
  showMore: true,
  bucketsTransform: identity
};